import Vue from 'vue'
import VueRouter from 'vue-router'
import courseCRouter from "./modules/course.js" //C端用户查看课程
import userIndex from "./modules/user.js" //C端用户查看课程
import loginIndex from "./modules/login.js" //C端用户查看课程
import { getLocalStorage,removeToken,clearLocalStorage } from '@/utils/auth'
Vue.use(VueRouter)
  const routes = [
    courseCRouter,
    userIndex,
    loginIndex
]

const router = new VueRouter({
  mode: 'hash', // require service support
  base: '/study/',
  // base: process.env.BASE_URL,
  routes
})



// 设置路由拦截
router.beforeEach(function(to, from, next) {
  if (to.path =='/login') {
    next()
  }else{
    if (!getLocalStorage('buyerId')||!getLocalStorage('buyerInfo')) {
      if (to.path !== '/login') {
        removeToken('mobile')
        removeToken('password')
        clearLocalStorage()
        return next('/login')
      }
    }
  }
  next()

})

export default router
